<template>
  <div v-redirect-if-no-permission:SURVEYS>
    <loading-component :value="loading" />
    <v-layout style="background-color: white; margin-bottom: -10px" justify-end>
      <router-link :to="{ name: 'CreateSurvey' }">
        <v-btn v-if="!isGovernment" color="primary">{{ $t("communication.surveys.newSurvey") }}</v-btn>
      </router-link>
    </v-layout>
    <data-table
      ref="table"
      :url="api.ACTIONS.SURVEYS"
      :enable-edit="false"
      :enable-delete="false"
      :enable-add="false"
      :formatter="formatters"
      :initial-url-search-params="capStatus"
      :actions-extra-main="actionsExtraMain"
      :conditional-action="conditionalActions"
      perPage="100"
      :fields-extra-main="surveyOptions"
      :fields-hidden-main="['user_id', 'updated_at', 'deleted_at', 'options', 'answers']"
      :titles="titles"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "Surveys",
  title() {
    return this.$t("communication.surveys.title");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      formatters: {
        question(value) {
          return value && value.length > 120 ? value.slice(0, 120) + "..." : value;
        },
        created_at(value) {
          return moment(value).format("DD MMM YYYY");
        },
        end_date(value) {
          return moment(value).format("DD MMM YYYY");
        },
      },
      surveys: "",
      surveyOptions: [],
      survey_options: ["yes", "no"],
      survey_answers: [],
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
      
    };
  },
  computed: {
     titles() {
                return {
                    "id": "#",
                    'title': this.$t('communication.surveys.surveyTitle'),
                    'question': this.$t('communication.surveys.question'),
                    'driver_type': this.$t('communication.surveys.driverType'),
                    'created_at': this.$t('communication.surveys.creationDate'),
                    "end_date": this.$t("communication.surveys.endDate")
                }
            },
    isGovernment() {
      return this.$store.state.user.roles[0].name === "Goverment";
    },
    surveyOptions() {
      return {
        value: this.survey_options,
      };
    },
    conditionalActions() {
      return {
        delete: () => !this.isGovernment,
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("communication.surveys.surveyAnswers"),
          icon: "info",
          action: (item) =>
            this.$router.push({
              name: "Survey",
              params: { id: item.id },
            }),
        },
        delete: {
          title: this.$t("common.delete"),
          icon: "delete",
          extras: { small: true, color: "red" },
          action: (item) => this.confirmDelete(item),
        },
      };
    },
  },
  methods: {
    confirmDelete(item) {
      this.$dialova({
        title: this.$t("communication.surveys.deletingSurvey"),
        paragraph: this.$t("communication.surveys.deleteConfirm", { title: item.title }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .delete(`${this.api.ACTIONS.SURVEYS}/${item.id}`)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("communication.surveys.deletedSuccessfully"), "green");
              close();
              this.$refs.table.getData();
            })
            .catch((err) => {
              let response = err.response;
              if (response && response.data && response.data.message) {
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              } else {
                window.getApp.$emit("SHOW_TOAST", this.$t("communication.surveys.somethingWentWrong"), "red");
              }
              close();
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped></style>
